import Config from 'traits/config';
import AbstractElement from './element';
import Listeners from 'system/listeners';
// import AbstractControl from './control'
// import { OfEntityInterface } from 'of/abstract/elements'
class AbstractModule extends AbstractElement {
    /********************
     * Instance Methods *
     ********************/
    constructor(element, options = {}) {
        super(element);
        /**********************
         * Instance Variables *
         **********************/
        this.config = new Config();
        this.moduleCanvases = {};
        this.moduleTemplates = {};
        // StackTrace.get().then(result=>{
        //     console.log('trace', result)
        // })
        // console.log('~~~module creation~~~', this, arguments)
        this.attributes = this.Element.getAttributes(true);
        this.configure(options);
        // this.initialize() //needs to be called by child can't be called here without double execution
    }
    set collection(collection) {
        this.entity.collection = this._collection = collection;
    }
    get collection() {
        return this._collection;
    }
    /**
     *
     * @param options object
     */
    configure(options = {}) {
        this.config.merge(options);
        this.config.mergeElement(this.element);
    }
    update() {
        this.render();
    }
    bindTo(instance, init = true) {
        super.bindTo(instance, init);
    }
    initialize() {
        // let entities = this.hasEntities()
        // this.hasEntities().forEach(entity => {
        //     if(entity.instance && entity.type == 'control'){
        //         console.log(entity)
        //         let control = <AbstractControl>entity.instance
        //         control.bindControl(this, this)
        //     } else if(entity.loading){
        //         console.log('loading')
        //     } else {
        //         console.log(entity)
        //     }
        // });
        // console.log(entities)
        // console.log(this.entity)
        // let entity = Entities.get(this.ID)
        this.render();
    }
    locateResources(reset = false) {
        if (reset) {
            this.moduleCanvases = {};
            this.moduleTemplates = {};
            // ['canvases', 'templates'].forEach(path=>{
            //     this.config.set(path, {})
            // })
        }
        // console.log('locate', this.entity)
        // console.log('has', this.entity.has)
        // console.log('element', this.element)
        // console.log('locate', this.ID, this.entity)
        Object.keys(this.entity.has).forEach(key => {
            const entity = this.entity.has[key];
            // console.log(this.ID, 'has', entity.element)
            if (!entity.element)
                return;
            if (!document.body.contains(entity.element)) {
                delete this.entity.has[key];
                return;
            }
            const name = entity.element.getAttribute('name') || 'default';
            switch (entity.type) {
                case 'canvas':
                    // console.log('has canvas', name, entity.element)
                    this.moduleCanvases[name] = entity;
                    // this.config.set(`canvases.${name}`, entity)
                    break;
                case 'template':
                    // console.log('template set', entity)
                    this.moduleTemplates[name] = entity;
                    // this.config.set(`templates.${name}`, entity)
                    break;
            }
        });
    }
    /**
     * @param locate Should resources be located before returning collection
     */
    getCanvases(locate = false, defaultToEntity = true) {
        // if(locate) 
        this.locateResources();
        // if(locate) console.log('located canvases', this.config.get('canvases'))
        // const canvases = this.config.get('canvases', {})
        const canvases = this.moduleCanvases;
        // console.log('canvases', canvases)
        // console.log('config', canvases)
        if (_.isEmpty(canvases) && defaultToEntity)
            canvases['default'] = this.entity;
        // console.log(canvases)
        return canvases;
    }
    getCanvas() {
        const canvases = this.getCanvases();
        return canvases['default'];
    }
    beforeRender() {
        this.locateResources();
    }
    async render() {
        return this.$element.html();
    }
    // findControls(): HTMLElement[] {
    //     let elements:HTMLElement[] = []
    //     let hasType = `[of-control!=""][of-control]`
    //     let hasControl = `[for-module!=""][for-module]`
    //     let selfControl = `[for-module="${this.ID}"]`
    //     $(selfControl).find(hasType).not(hasControl).each((index, element)=>{
    //         elements.push(element)
    //     })
    //     $(`${hasType}${selfControl}`).each((index, element)=>{
    //         elements.push(element)
    //     })
    //     return elements
    // }
    // applyControls(){
    // }
    // addControl(element:HTMLElement){
    //     console.log('hit')
    // }
    // applyControl(controlID:string){
    //     // console.log('apply', controlID)
    //     // console.log('apply control', controlID)
    // }
    /**
     * Called at registration after instance is created
     * @param instance
     */
    applyBinding(instance) {
        var _a;
        //... apply modifier
        // console.log('apply', instance)
        // console.log('module', this.ID, 'control',  instance.ID )
        // console.log(instance)
        if (instance.element) {
            // console.log('add', instance.element)
            /**
             * REVIEW
             * currently adds to modifiers
             */
            // console.log(instance.element)
            (_a = this.collection) === null || _a === void 0 ? void 0 : _a.modifiers.addElement(instance.element);
        }
        // .load(this.findControls())
        // console.log(instance)
        // let controls = Modules.get(this.ID).has
        // Object.keys(controls).forEach(key=>{
        //     let value = controls[key]
        //     ids.push(value.ID)
        // })
        //count controls
        // const ids:string[] = []
        // Object.keys(controls).forEach(key=>{
        //     let value = controls[key]
        //     ids.push(value.ID)
        // })
        // console.log(ids.length, ids)
        // console.log(instance.instance)
        // console.log('apply Of', instance)
        // instance.instance.events.observe(()=>{
        // }).complete(()=>{
        //     console.log('ELEMENT DESTRUCTED')
        // })
    }
    removeBinding(instance) {
    }
    // removeControl(instance:ControlInterface|ModuleInterface){
    // }
    on(event, element, callback, options = {}) {
        const listener = { event: event, element: element, callback: callback, options: options, listener_id: 0 };
        listener.listener_id = Listeners.add(listener.event, element, listener.callback, options);
        // listener.element.addEventListener(listener.event, listener.callback)
        this._listeners.push(listener.listener_id);
        // this.registeredListeners.push(listener)
    }
    // startRegisteredListeners(){
    //     for(const listener of this.registeredListeners){
    //         this._listeners.push(Listeners.add(listener.event, listener.element, listener.callback, listener.options))
    //         // listener.element.addEventListener(listener.event, listener.callback)
    //     }    
    // }
    destruct() {
        var _a;
        super.destruct();
        (_a = this.collection) === null || _a === void 0 ? void 0 : _a.destruct();
        this.events.destruct();
        this.$element.remove();
        // delete this
    }
}
export default AbstractModule;
export { AbstractModule };
